import { formatDayShort } from './intlFormatters';

// The freshness statuses that mean the latest months have no statement.
const LATE_STATUSES = ['behind', 'outdated'];

/**
 * What an account's statements cover, in words: "Statement through Sep 30",
 * or "Statement behind · through Jul 31" when the latest months have none.
 * Null for an account with no statement (cash, a person, a manual account).
 *
 * @param {object} freshness - the account's row of /source-files/account-freshness
 * @param {function} t - `t` of the accounts namespace
 */
export function statementLine(freshness, t) {
  if (!freshness?.covered_through || freshness.status === 'none') return null;
  const date = formatDayShort(freshness.covered_through);
  return LATE_STATUSES.includes(freshness.status)
    ? { text: t('row.statementBehind', { date }), late: true }
    : { text: t('row.statementThrough', { date }), late: false };
}
